import { Colors } from "@blueprintjs/core";
import { useNavigate, useParams } from "react-router-dom";

import SEOHelmet from "@/components/helpers/seo/SEOHelmet";
import {
  allowBuyCredits,
  isInWorkspace,
} from "@/components/helpers/workspace/permissions";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import Nav from "@/components/nav/Nav";
import Authenticate from "@/components/pages_logged_in/Authenticate";
import BuyCreditsForm from "@/components/pieces/buy-credits";
import AffirmTag from "@/components/pieces/buy-credits/AffirmTag";
import CoachingSvg from "@/components/pieces/icons/svg/coaching";
import {
  LIGHTEST_BACKGROUND,
  SIDE_NAV_WIDTH,
  SITE_NAME,
  STANDARD_APP_MAX_WIDTH,
  SUBTEXT_COLOR,
} from "@/css/constants";

export default function BuyCreditsContainer() {
  const navigate = useNavigate();
  const { slug } = useParams();

  if (!allowBuyCredits()) {
    navigate("/dashboard");
    return null;
  }

  return (
    <Authenticate maxWidth="100%" layout="dashboard">
      <SEOHelmet
        title={`Buy Credits - ${SITE_NAME}`}
        description="Buy credits to invest in your development."
        canonicalPath="`/buy"
        image="https://placement-pub.s3.us-east-2.amazonaws.com/buy-sessions-meta.png"
      />
      <Nav />
      <Box ml={[0, 0, SIDE_NAV_WIDTH]}>
        <Media greaterThan="xs">
          <Box className="bbs" py={4} bg={Colors.WHITE}>
            <Box
              className="container"
              m="0 auto"
              maxWidth={STANDARD_APP_MAX_WIDTH}
              bg={Colors.WHITE}
              px={[14, 24]}
            >
              <Flex alignItems="center">
                <CoachingSvg size={26} />
                <Box ml={3}>
                  <h1 style={{ fontSize: 28, margin: 0 }}>Buy Credits</h1>
                </Box>
              </Flex>
              <Box color={SUBTEXT_COLOR} mt={2}>
                {isInWorkspace()
                  ? "Buy credits to distribute to members of your organization"
                  : "Save money and invest in yourself by committing to your career development"}
              </Box>
            </Box>
          </Box>
        </Media>
        <Box pt={4} pb={6} bg={LIGHTEST_BACKGROUND}>
          <Box
            className="container"
            m="0 auto"
            maxWidth={STANDARD_APP_MAX_WIDTH}
            px={[3, 24]}
          >
            <Box width={1}>
              <BuyCreditsForm productSlug={slug} />
            </Box>
          </Box>
        </Box>
      </Box>
      <AffirmTag />
    </Authenticate>
  );
}
